var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vocabulary-autocomplete"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchValue,
      expression: "searchValue"
    }],
    ref: "inputRef",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.searchValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchValue = $event.target.value;
      }, _vm.handleInput],
      "keydown": _vm.handleKeydown,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }), _vm.showDropdown ? _c('div', {
    staticClass: "dropdown-list"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "dropdown-message"
  }, [_vm._v(" 검색 중... ")]) : [_vm.suggestions.length === 0 && _vm.hasSearched && _vm.searchValue.trim() ? _c('div', {
    staticClass: "dropdown-no-result"
  }, [_c('div', {
    staticClass: "no-result-message"
  }, [_vm._v("검색 결과가 없습니다")]), _c('button', {
    staticClass: "btn-create",
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": function ($event) {
        $event.preventDefault();
        return _vm.openCreateModal.apply(null, arguments);
      }
    }
  }, [_vm._v(" 생성하기 ")])]) : _vm._l(_vm.suggestions, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "dropdown-item",
      class: {
        'active': index === _vm.selectedIndex
      },
      on: {
        "mousedown": function ($event) {
          $event.preventDefault();
          return _vm.selectItem(item);
        },
        "mouseenter": function ($event) {
          _vm.selectedIndex = index;
        }
      }
    }, [_c('div', {
      staticClass: "item-code"
    }, [_vm._v(_vm._s(item.code))]), _c('div', {
      staticClass: "item-system"
    }, [item.system1 ? _c('span', [_vm._v(_vm._s(item.system1))]) : _vm._e(), item.system1 && item.system2 ? _c('span', [_vm._v(" > ")]) : _vm._e(), item.system2 ? _c('span', [_vm._v(_vm._s(item.system2))]) : _vm._e()]), item.description ? _c('div', {
      staticClass: "item-desc"
    }, [_vm._v(_vm._s(item.description))]) : _vm._e()]);
  })]], 2) : _vm._e(), _vm.showCreateModal ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("어휘 생성")]), _c('button', {
    staticClass: "btn-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeCreateModal
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("어휘코드 *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.code,
      expression: "createForm.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "어휘코드를 입력하세요"
    },
    domProps: {
      "value": _vm.createForm.code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.createForm, "code", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("체계1")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.system1,
      expression: "createForm.system1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "체계1을 입력하세요"
    },
    domProps: {
      "value": _vm.createForm.system1
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.createForm, "system1", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("체계2")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.system2,
      expression: "createForm.system2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.createForm.system2
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.createForm, "system2", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("설명")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.description,
      expression: "createForm.description"
    }],
    attrs: {
      "placeholder": "설명을 입력하세요",
      "rows": "3"
    },
    domProps: {
      "value": _vm.createForm.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.createForm, "description", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeCreateModal
    }
  }, [_vm._v("취소")]), _c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createVocabulary
    }
  }, [_vm._v("생성")])])])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }